"use client";

import { c as _c } from "react/compiler-runtime";
import { type AppEnumType } from "@shared-database/enums";
import { useLocalStorage } from "@shared-utils/hooks/use-local-storage";
import { translations } from "@shared-utils/localization/translations";
import _ from "lodash";
import React, { createContext, useContext, type ReactNode } from "react";
export type TranslateOptions = {
  app: AppEnumType;
  translationKey: string;
  value: string;
  description: string;
};
type LocalizationContextType = {
  translate: (options: TranslateOptions) => string;
  setLanguage: (lang: string) => void;
  language: string;
};

// Create context
const LocalizationContext = createContext<LocalizationContextType | undefined>(undefined);

// Provider props
type LocalizationProviderProps = {
  children: ReactNode;
};

// Provider component
export const LocalizationProvider: React.FC<LocalizationProviderProps> = t0 => {
  const $ = _c(9);
  const {
    children
  } = t0;
  const [language, setLanguage] = useLocalStorage("language-", "EN");
  let t1;
  if ($[0] !== language) {
    t1 = options => {
      const translated = _.get(translations, [options.app, language, options.translationKey], options.value);
      return translated;
    };
    $[0] = language;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const translate = t1;
  let t2;
  if ($[2] !== language || $[3] !== setLanguage || $[4] !== translate) {
    t2 = {
      translate,
      setLanguage,
      language
    };
    $[2] = language;
    $[3] = setLanguage;
    $[4] = translate;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] !== children || $[7] !== t2) {
    t3 = <LocalizationContext.Provider value={t2}>{children}</LocalizationContext.Provider>;
    $[6] = children;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  return t3;
};

// Custom hook
export const useLocalization = () => {
  const context = useContext(LocalizationContext);
  if (!context) {
    throw new Error("useTranslation must be used within a TranslationProvider");
  }
  return context;
};